export function formSort(direction, names, dates){
  switch(direction){
    case 'asc':
      return alphaSort(direction, names);
    case 'desc':
      return alphaSort(direction, names);
    case 'createdDateNewest':
      return dateSort(direction, dates);
    case 'createdDateOldest':
      return dateSort(direction, dates);
    case 'lastModifiedDateNewest':
      return dateSort(direction, dates);
    case 'lastModifiedDateOldest':
      return dateSort(direction, dates);
    default:
      return 0;
  }
}

export function alphaSort(direction, map = x => x) {
  return (a, b) => {
    switch (direction) {
      case 'asc':
        return map(a).trim().toLowerCase().localeCompare(map(b).trim().toLowerCase());
      case 'desc':
        return map(b).trim().toLowerCase().localeCompare(map(a).trim().toLowerCase());
      default:
        return 0;
    }
  }
}

export function dateSort(direction, datesMap = y => y) {
  return (a, b) => {
    switch (direction) {
      case 'createdDateNewest':
        return datesMap(b).created - datesMap(a).created;
      case 'createdDateOldest':
        return datesMap(a).created - datesMap(b).created;
      case 'lastModifiedDateNewest':
        return datesMap(b).lastModified - datesMap(a).lastModified;
      case 'lastModifiedDateOldest':
        return datesMap(a).lastModified - datesMap(b).lastModified;
      default:
        return 0;
    }
  }
}
